import { Subject } from "rxjs";
import { Injectable } from '@angular/core';

export interface RealtimeEvent {
	type: string;
	data?: any;
  }

@Injectable({
	providedIn: 'root'
})
export class RealtimeService {

	private socket?: WebSocket;
	private eventsSubject = new Subject<RealtimeEvent>();

	events$ = this.eventsSubject.asObservable();

	connect(): void {
		// Half-baked; commenting for now
		// const protocol =
		// window.location.protocol === 'https:' ? 'wss:' : 'ws:';

		// const url = `${protocol}//${window.location.host}/api/api/realtime`;

		// this.socket = new WebSocket(url);

		// this.socket.onmessage = event => {
		// 	const message = JSON.parse(event.data) as RealtimeEvent;
		// 	this.eventsSubject.next(message);
		// };

		// this.socket.onclose = () => {
		// this.socket = undefined;

		// };
	}
}